const RICHPANEL_LAUNCHER_SELECTOR = '[aria-label*="chat" i], [aria-label*="messenger" i], .richpanel-launcher, #richpanel-launcher';

function toggleRichpanel() {
  // Richpanel's live controller opens the chat whether or not its window has
  // loaded. `window.Richpanel` is a copy Richpanel makes at start-up whose
  // state goes stale: its showMessenger() reloads the chat window, never opens
  // it, and takes the bubble away with it.
  const proxy = window.RichpanelAppProxy;
  if (proxy && typeof proxy.showMessenger === 'function') return proxy.showMessenger();

  const candidates = [
    window.Richpanel,
    window.RichPanel,
    window.richpanel,
    window.RichpanelMessenger,
  ];

  for (const api of candidates) {
    if (!api) continue;
    if (typeof api.toggle === 'function') return api.toggle();
    if (typeof api.open === 'function') return api.open();
    if (typeof api.show === 'function') return api.show();
    if (typeof api === 'function') return api('toggle');
  }

  document.querySelector(RICHPANEL_LAUNCHER_SELECTOR)?.click();
}

class LoverseFaq extends HTMLElement {
  connectedCallback() {
    const items = this.querySelector('[data-lve-faq-items]');
    if (items) {
      items.addEventListener(
        'toggle',
        (event) => {
          const target = event.target;
          if (!(target instanceof HTMLDetailsElement) || !target.open) return;
          items.querySelectorAll('details[open]').forEach((other) => {
            if (other !== target) other.removeAttribute('open');
          });
        },
        true,
      );
    }

    const chatBtn = this.querySelector('[data-lve-faq-chat]');
    if (chatBtn) {
      chatBtn.addEventListener('click', (event) => {
        event.preventDefault();
        toggleRichpanel();
      });
    }
  }
}

if (!customElements.get('loverse-faq')) {
  customElements.define('loverse-faq', LoverseFaq);
}
